export enum COMMISSION_UPLOAD_STATUS {
  PROCESSING = 0,
  PROCESSED = 1,
  FAILED = 2
};
